document.addEventListener('DOMContentLoaded', function() {

    // Check if current URL matches or contains the href of elements with auto-open class
    function shouldAutoOpen(href) {
        if (!href) return false;

        const currentLocation = window.location.href;
        const currentPath = window.location.pathname;

        if (currentLocation === href) return true;

        try {
            const hrefUrl = new URL(href, window.location.origin);
            const hrefPath = hrefUrl.pathname;

            if (currentPath.includes(hrefPath) && hrefPath !== '/') return true;

            const currentSegments = currentPath.split('/').filter(Boolean);
            const hrefSegments = hrefPath.split('/').filter(Boolean);

            return hrefSegments.some(segment => currentSegments.includes(segment));
        } catch (e) {
            return currentPath.includes(href) || href.includes(currentPath);
        }
    }

    // Auto-open submenu based on auto-open class and href matching
    function autoOpenSubmenu() {
        const autoOpenElements = document.querySelectorAll('.auto-open');

        if (!autoOpenElements.length) {
            return;
        }

        autoOpenElements.forEach(element => {
            const href = element.getAttribute('href') || element.querySelector('a')?.getAttribute('href');

            if (href && shouldAutoOpen(href)) {
                const parentSubmenu = element.closest('.wp-block-navigation-submenu');
                const submenuToggle = parentSubmenu?.querySelector('.wp-block-navigation-submenu__toggle');

                if (submenuToggle && parentSubmenu) {
                    submenuToggle.setAttribute('aria-expanded', 'true');

                    parentSubmenu.classList.add('is-open');

                    // Find and update the WordPress interactive data context if it exists
                    const wpContext = parentSubmenu.getAttribute('data-wp-context');
                    if (wpContext) {
                        try {
                            const contextData = JSON.parse(wpContext);
                            contextData.submenuOpenedBy.click = true;
                            parentSubmenu.setAttribute('data-wp-context', JSON.stringify(contextData));
                        } catch (e) {
                            console.log('WordPress navigation context update failed, using fallback method');
                        }
                    }

                    // Alternative method: simulate click if WordPress interactive doesn't work
                    setTimeout(() => {
                        const isExpanded = submenuToggle.getAttribute('aria-expanded') === 'true';
                        if (!isExpanded) {
                            submenuToggle.click();
                        }
                    }, 100);
                }
            }
        });
    }

    // Fallback function to add current-menu-item class to matching navigation items
    function addCurrentMenuItemClass() {
        const currentLocation = window.location.href;
        const currentPath = window.location.pathname;

        // Get all navigation links
        const navLinks = document.querySelectorAll('.wp-block-navigation a');
        let exactMatchFound = false;
        let exactMatchItem = null;

        // First pass: remove all current classes and find exact match
        navLinks.forEach(link => {
            const href = link.getAttribute('href');
            const navItem = link.closest('.wp-block-navigation-item');

            if (!href || !navItem) return;

            // Remove existing current classes first
            navItem.classList.remove('current-menu-item', 'current-menu-ancestor', 'current-page-ancestor');

            // Check for exact URL match
            if (currentLocation === href || currentPath === href) {
                exactMatchFound = true;
                exactMatchItem = navItem;
            }
        });

        // If exact match found, only highlight that item
        if (exactMatchFound && exactMatchItem) {
            exactMatchItem.classList.add('current-menu-item');

            // Add current-menu-ancestor to parent submenu
            const parentSubmenu = exactMatchItem.closest('.wp-block-navigation-submenu');
            if (parentSubmenu) {
                parentSubmenu.classList.add('current-menu-ancestor', 'current-page-ancestor');

                // Also mark the submenu toggle as current ancestor
                const submenuToggle = parentSubmenu.querySelector('.wp-block-navigation-submenu__toggle');
                if (submenuToggle) {
                    const toggleNavItem = submenuToggle.closest('.wp-block-navigation-item');
                    if (toggleNavItem) {
                        toggleNavItem.classList.add('current-menu-ancestor', 'current-page-ancestor');
                    }
                }
            }
        } else {
            // If no exact match, fall back to path matching for the best match
            let bestMatch = null;
            let longestMatch = 0;

            navLinks.forEach(link => {
                const href = link.getAttribute('href');
                const navItem = link.closest('.wp-block-navigation-item');

                if (!href || !navItem) return;

                try {
                    const hrefUrl = new URL(href, window.location.origin);
                    const hrefPath = hrefUrl.pathname;

                    // Find the longest matching path
                    if (currentPath.startsWith(hrefPath) && hrefPath !== '/' && hrefPath.length > longestMatch) {
                        longestMatch = hrefPath.length;
                        bestMatch = navItem;
                    }
                } catch (e) {
                    // Skip invalid URLs
                }
            });

            // Apply classes to best match only
            if (bestMatch) {
                bestMatch.classList.add('current-menu-item');

                // Add current-menu-ancestor to parent submenu
                const parentSubmenu = bestMatch.closest('.wp-block-navigation-submenu');
                if (parentSubmenu) {
                    parentSubmenu.classList.add('current-menu-ancestor', 'current-page-ancestor');

                    // Also mark the submenu toggle as current ancestor
                    const submenuToggle = parentSubmenu.querySelector('.wp-block-navigation-submenu__toggle');
                    if (submenuToggle) {
                        const toggleNavItem = submenuToggle.closest('.wp-block-navigation-item');
                        if (toggleNavItem) {
                            toggleNavItem.classList.add('current-menu-ancestor', 'current-page-ancestor');
                        }
                    }
                }
            }
        }
    }

    // Handle navigation clicks to prevent submenu interference
    

    // Main function to auto-open matching submenus
    function autoOpenMenus() {
        autoOpenSubmenu();
        addCurrentMenuItemClass();
    }

    // Run the function after DOM is loaded
    // autoOpenMenus();
    
    // Also run after a short delay to ensure WordPress navigation scripts have loaded
    setTimeout(autoOpenMenus, 500);

    // Listen for navigation changes (for SPA-like behavior)
    // let lastUrl = location.href;
    /* new MutationObserver(() => {
        const url = location.href;
        if (url !== lastUrl) {
            lastUrl = url;
            setTimeout(autoOpenMenus, 100);
        }
    }).observe(document, { subtree: true, childList: true }); */

});
